<template>
  <div class="aboutCenter clearfix">
    <div class="aa">
      <ui-navigation></ui-navigation>
    </div>
    <div class="aboutBox">
      <h1 class="mb-5">一站式为客户解决方案</h1>
      <h4 class="mb-4">关于我们</h4>
      <p>
        雪帝数字音频有限公司成立于2008年，是一家专门从事电脑音乐设备，数码乐器，数字音频及相关领域产品推广销售和研制 开发的高新技术企业。
      </p>
      <p>
        从2000年起，公司逐步成为专业的品牌代理公司，为中国音乐人带来优质的国际品牌，尖端的技术，和最新的理念。为了配合中国市场的需求，公司开发 了兼销售，演示，培训，教育，研发为一体的综合性可持续发展代理销售模式，在业界建立起了一种创新的营销思路。
      </p>
      <p>
        在成立至今的十年间，公司一直以专业音乐家的角度参与到数字化音乐设备市场的发展中。从有选择地代理国际著名专业品牌，到参与众多合作厂家的项 目开发设计，公司一直关注和配合新一代音乐人的需求，为行业的发展提供全新的视角。
      </p>
      <p>
        在未来的日子里，公司会一如既往地关注中国用户的需求，秉承与国际市场的紧密合作，与中国音乐人和音乐爱好者一起，把握先机，赢得挑战，与世界同步!
      </p>
      <hr class="mt-5">
      <h4 class="mb-4" >Our core values</h4>
      <p>
        Xuedi Digital Audio aims to provide a more professional and comprehensive “one-stop” solution since we established. We are here to support our customers with:
      </p>
      <ul class="mb-3">
        <li>Sincerity in our service attitude</li>
        <li>Caring your needs</li>
        <li>Honesty to provide you the best solution with the best fit products</li>
        <li>Liability to give you the most comprehensive technical support</li>
      </ul>
      <p>
        Since 2000, Xuedi Digital Audio Co. was gradually turning into an exclusive brand distribution company. The main goal was to bring the greatest international brands, the latest technology, and newest concepts into this industry in China. To meet the needs in Chinese market, Xuedi Digital Audio Co. creatively developed a sustainable business model that integrated the sales, demonstrations, training, education, and development together. In the past ten years, Xuedi Digital Audio Co. kept devoting all the passions and knowledge into the music technology industry as an expert. And from distributing famous global brands selectively, to involving in many developing projects together with manufacturers, Central Music Co. is always paying closest attention to the musicians of new generations, and is always trying to introduce the latest ideas to the industry!
      </p>
      <p>
        In the future, Xuedi Digital Audio Co. will keep improving further together with our musicians, think what customers think, work close with the international market, grasp the chance, and stay One Step Ahead as always.
      </p>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import Navigation from '@/components/about/Navigation.vue';

export default {
  name: 'aboutCenter',
  mixins: [generalMix],
  data () {
    return {
    }
  },
  components:{
    'ui-navigation': Navigation
  },
  mounted() {
    $('html').removeClass('scrollHide');
  }
}
</script>

<style scoped lang='less'>
.aboutCenter{
  display: flex;
  div.aa{
    width: 200px;
    margin-right: 30px;
  }
  div.aboutBox{
    flex: 1;
    background-color: #FFFFFF;
    border-radius: 15px;
    padding: 30px;
    h1{
      font-size: 32px;
      color: #FF7B00;
    }
    ul{
      list-style: disc;
      padding-left: 30px;
    }
  }
}
@media (max-width: 992px) {
  .aboutCenter{
    flex-direction: column;
    div.aa{
      margin: 0;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/Jianjie.vue